import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FreeTrial } from '@app/Models/free-trial.model';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';

export interface ExtendTrialResult {
    isSave: boolean;
    payload: any;
}

@Component({
    selector: 'app-extend-trial-popup',
    styleUrls: ['./extend-trial-popup.component.scss'],
    templateUrl: './extend-trial-popup.component.html',
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, MatDatepickerInput, FormsModule, ReactiveFormsModule, MatDatepickerToggle, MatSuffix, MatDatepicker, MatDialogActions, MatButton]
})
export class ExtendTrialPopupComponent {
    daysOfExtension = new UntypedFormControl(7);
    trialEndDate = new UntypedFormControl(this.getNewExpiryDate());

    constructor(public dialogRef: MatDialogRef<ExtendTrialPopupComponent, ExtendTrialResult>,
        @Inject(MAT_DIALOG_DATA) public freeTrialProperties: FreeTrial) { }

    closeDialog(isSave: boolean): void {
        const dialogResult: ExtendTrialResult = { isSave, payload: this.trialEndDate.value };
        this.dialogRef.close(dialogResult);
    }

    getMinExpiryDate(): Date {
        const startDate = this.getTodayDate();
        const minExpiryDate = Math.round(startDate.getTime() + (1000 * 60 * 60 * 24));
        return new Date(minExpiryDate);
    }

    getMaxExpiryDate(): Date {
      const startDate = new Date(this.freeTrialProperties.TrialStartDate ?? null);
      const maximumDate = Math.round(startDate.getTime() + (1000 * 60 * 60 * 24 * 180));
      return new Date(maximumDate);
    }

    getMaxNumberOfDays(): number {
        const maxExpiryDate = this.getMaxExpiryDate();
        const today = this.getTodayDate();
        return Math.round((maxExpiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    }

    updateExtensionDays(): void {
        this.daysOfExtension.setValue(this.getDifferenceOfDays());
    }

    updateExpiryDate(): void {
        this.trialEndDate.setValue(this.getNewExpiryDate());
    }

    isFormValid(): boolean {
        return this.trialEndDate.valid;
    }

    private getDifferenceOfDays(): number {
        const expiryDate = new Date(this.trialEndDate.value ?? null);
        const today = this.getTodayDate();
        return Math.round((expiryDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    }

    private getNewExpiryDate(): Date {
        const todayDate = this.getTodayDate();
        const newExpiryDate = todayDate.getTime() + (1000 * 60 * 60 * 24 * this.daysOfExtension.value);
        return new Date(newExpiryDate);
    }

    private getTodayDate(): Date {
        const todayDate = new Date();
        todayDate.setHours(0,0,0,0);
        return todayDate;
    }
}
